module.exports = __webpack_public_path__ + "assets/img/fea09ffc1f6ff0506871b931c5402309.png";